export const LOAD_USERS = 'LOAD_USERS';
export const ADD_USER = 'ADD_USER';
export const UPDATE_USER = 'UPDATE_USER';
export const DELETE_USER = 'DELETE_USER';
export const AUTHENTICATE_USER = 'AUTHENTICATE_USER';
export const GET_ACTIVE_USER = 'GET_ACTIVE_USER';
export const UPDATE_ACTIVE_USER = 'UPDATE_ACTIVE_USER';

export const SYNCHRO_GET_ACTIVE_USER = 'SYNCHRO_GET_ACTIVE_USER';

export const SET_ALL_USERS = "SET_ALL_USERS";

export const CHANGE_PASSWORD_MESSAGE = "CHANGE_PASSWORD_MESSAGE"